<template>
    <div id="about-section" class="pt-7 pb-7">
        <div class="container">
            <div class="text-default text-center">
                <h2 class="display-3 montserrat-bold text-uppercase mb-3">About <span class="text-danger inline">Cutiefy</span></h2>
                <p class="font-weight-400 mb-7">
                    Cutiefy is a location-based, on-demand app to book salon, spa, or aesthetic clinic services when you need it and where you want it done from your choice of available Cutiefy accredited service providers nearby.
                </p>
            </div>
            <div class="container-fluid text-default">
                <div class="row">
                    <div class="col-lg-6 text-right">
                        <div class="parallax d-none d-lg-block" data-speed="0.05" data-initial-offset="-10">
                            <img :src="mobileImage" class="parallax-item" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <h2 class="text-default display-4 montserrat-bold text-uppercase mb-3">
                            <span class="text-danger inline">Best</span> Mobile App
                        </h2>
                        <p class="font-weight-400 mb-4">
                            Cutiefy will revolutionize the beauty industry by changing how clients choose, book and pay for their desired services. It will also help improve and make easy the management of the service providers’ services, appointments, schedules, and employees.
                        </p>
                        <p class="font-weight-400">
                            <span class="font-weight-700 inline">Easy to Use</span> – Cutiefy Mobile App is user-friendly with a few easy steps to complete your booking.
                        </p>
                        <p class="font-weight-400">
                            <span class="font-weight-700 inline">Flexible & Convenient</span> – Book your services when you need it and where you want it done. Compare the Cutiefy accredited service providers’ prices based on the price range displayed.
                        </p>
                        <p class="font-weight-400">
                            <span class="font-weight-700 inline">Credible</span> – Cutiefy accredited service providers are legitimate and registered businesses. Cutiefy is owned and operated by HEplusUS Inc., a duly registered private corporation in the Philippines.
                        </p>
                        <div class="mt-5">
                            <!-- <a href="{{ route("pages.how-it-works.index") }}" class="btn btn-danger btn-xl text-uppercase mr-4">Download</a> -->
                            <a href="/how-it-works" class="btn btn-xl btn-secondary">Learn more</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { resource } from "@utils/network";
export default {
    name: "AboutSection",
    data: () => ({
        mobileImage: resource('images/mobile-phone2.png'),
    })
}
</script>